import React from "react";

const VoiceSection = () => {
  return (
    <section
      className="voice-section"
      aria-labelledby="voice-title"
    >
      <div className="container voice-container">

        <div className="voice-content">

          <p className="section-label light">
            <span />
            YOUR VOICE MATTERS
          </p>

          <h2 id="voice-title">
            Your concerns.
            <br />
            Your community.
            <br />
            <em>Your voice.</em>
          </h2>

          <p>
            Have a concern, suggestion or issue
            affecting your community? Connect with
            the constituency office.
          </p>

          <a
            href="#contact"
            className="btn btn-gold"
          >
            Submit a Concern
            <span aria-hidden="true">
              →
            </span>
          </a>

        </div>

        <div
          className="voice-decoration"
          aria-hidden="true"
        >
          <div />
          <div />
          <div />
          <span>AF</span>
        </div>

      </div>
    </section>
  );
};

export default VoiceSection;